<template>
  <div class="logo-cropper">
    <Cropper
      ref="cropper"
      class="cropper"
      :src="imageObject"
      :default-size="defaultSize"
      :resize-image="{
        adjustStencil: true,
      }"
      :canvas="{
        width: 500,
        height: 300,
      }"
      :stencil-props="{
        aspectRatio: 5 / 3,
      }"
      :transitions="false"
      :debounce="false"
      @change="onChange"
    />
    <!-- <div class="logo-cropper__controls">
      <button type="button" class="logo-cropper__control-button">
        <IconCrop color="black" />
        <span>Crop</span>
      </button>
      <LogoCropperZoomBar :zoom="zoom" @change="onZoom" />
    </div> -->
  </div>
</template>

<script>
  import { Cropper } from 'vue-advanced-cropper';
  import 'vue-advanced-cropper/dist/style.css';

  import IconCrop from '~/components/icon/IconCrop.vue';
  import LogoCropperZoomBar from '~/components/logo/LogoCropperZoomBar.vue';

  export default {
    name: 'LogoCropper',
    components: {
      Cropper,
      IconCrop,
      LogoCropperZoomBar,
    },
    props: {
      image: {
        type: File,
        required: true,
      },
    },
    data: () => ({
      resultImg: null,
      zoom: 0,
    }),
    computed: {
      imageObject() {
        return URL.createObjectURL(this.image);
      },
      imageSize() {
        return {
          width:
            this.$refs.cropper && this.$refs.cropper.width
              ? this.$refs.cropper.width
              : 0,
          height:
            this.$refs.cropper && this.$refs.cropper.height
              ? this.$refs.cropper.height
              : 0,
        };
      },
    },
    methods: {
      defaultSize({ imageSize }) {
        return {
          width: Math.min(imageSize.height, imageSize.width),
          height: Math.min(imageSize.height, imageSize.width),
        };
      },
      onChange(result) {
        const cropper = this.$refs.cropper;
        if (!cropper) return;

        const { imageSize, visibleArea } = cropper;
        const { canvas } = cropper.getResult();

        // CLEAR THE OLD CROPPED IMAGE SO THE USER DOESN'T ACCENTENTALLY DOWNLOAD THE OLD ONE
        this.$emit('file-cropped', null);

        // SEND THE CROPPED IMAGE TO THE PARENT COMPONENT
        canvas.toBlob((blob) => {
          this.$emit('file-cropped', blob);
        }, 'image/png');

        if (
          imageSize.width / imageSize.height >
          visibleArea.width / visibleArea.height
        ) {
          // Determine the position of slider bullet
          // It's 0 if the stencil has the maximum size of the image or the image is zoomed out as much as possible and it's 1 if the has the minimum size
          this.zoom =
            (cropper.imageSize.height - cropper.visibleArea.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
        } else {
          this.zoom =
            (cropper.imageSize.width - cropper.visibleArea.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
        }
      },
      onZoom(value) {
        const cropper = this.$refs.cropper;
        if (!cropper) return;

        if (cropper.imageSize.height < cropper.imageSize.width) {
          const minHeight = cropper.sizeRestrictions.minHeight;
          const imageHeight = cropper.imageSize.height;
          // Determine the current absolute zoom and the new absolute zoom
          // to calculate the sought relative zoom value
          cropper.zoom(
            (imageHeight - this.zoom * (imageHeight - minHeight)) /
              (imageHeight - value * (imageHeight - minHeight))
          );
        } else {
          const minWidth = cropper.sizeRestrictions.minWidth;
          const imageWidth = cropper.imageSize.width;
          cropper.zoom(
            (imageWidth - this.zoom * (imageWidth - minWidth)) /
              (imageWidth - value * (imageWidth - minWidth))
          );
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .logo-cropper {
    width: 100%;
    height: auto;

    .cropper {
      width: 100%;
      // height: 500px;
      background: #ddd;

      :deep(img) {
        max-height: inherit;
      }
    }

    &__controls {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
      margin-top: 1rem;
      margin-bottom: 3rem;
    }
    &__control-button {
      background-color: transparent;
      border: none;
      display: flex;
      align-items: center;
    }
  }
</style>
